import { FULFILLED, REJECTED } from '../actions/ActionUtils';
import { catchError, defer, from, mergeMap, Observable, retry } from 'rxjs';
import { ofType, Epic, StateObservable } from 'redux-observable';
import { SHOW_MESSAGES } from '../../enrol/actions/Actions';
import { commonErrorToValidationError, toValidationError } from '../utils/ErrorUtils';
import { AxiosResponse } from 'axios';
import { CommonError } from '@api';
import { IAction, IshAction } from '../../actions/IshAction';
import Bugsnag from '@bugsnag/js';
import { IshState } from '../../services/IshState';

const notifyBugsnagApiError = (error: any) => {
  if (typeof error === 'object' && error.status !== 400 && error.status !== 503) {
    Bugsnag.notify(new Error('Checkout API error'), function (event) {
      event.errors[0].errorClass = 'Checkout API error';
      event.addMetadata('Checkout API error data', {
        ...error
      });
    });
  }
};

export function mapPayload(actionType: string) {
  return function (payload: any) {
    return {
      type: FULFILLED(actionType),
      payload,
    };
  };
}

export function mapError(actionType: string) {
  return function (payload: any) {
    notifyBugsnagApiError(payload);
    return from<IshAction[]>([{
      type: REJECTED(actionType),
      payload,
      error: true,
    }]);
  };
}

export interface Request<V = any, P = any> {
  type: string;
  getData: (payload: P, state: IshState) => Promise<V>;
  processData: (value: V, state: IshState, payload?: P) => IAction<any>[] | Observable<any>;
  processError?: (data: any) => IAction<any>[] | Observable<any>;
}


export const showCommonError = (error: CommonError): { type: string, payload: any } => {
  return { type: SHOW_MESSAGES, payload: commonErrorToValidationError(error) };
};

export const ProcessError = (data: AxiosResponse): { type: string, payload?: any }[] => {
  notifyBugsnagApiError(data);
  return [{ type: SHOW_MESSAGES, payload: toValidationError(data) }];
};


export const Create = <V, S>(request: Request<V, S>): Epic<any, any> => (action$: Observable<any>, store: StateObservable<IshState>): Observable<any> => action$.pipe(
  ofType(request.type),
  mergeMap(action => from(request.getData(action.payload, store.value))
    .pipe(
      mergeMap(data => request.processData(data, store.value, action.payload)),
      catchError(data => {
        return request.processError ? request.processError(data) : ProcessError(data);
      })
    ))
);

export const Reply = <V, S>(request: Request<V, S>, retryTimes: number): Epic<any, any> => {
  return (action$: Observable<any>, store: StateObservable<IshState>): Observable<any> => {
    return action$.pipe(
      ofType(request.type),
      mergeMap((action: IAction<any>) => defer(() => request.getData(action.payload, store.value)).pipe(
        retry(retryTimes),
        mergeMap((data: V) => request.processData(data, store.value)),
        catchError(data => request.processError(data))
      ))
    );
  };
};
